import { stringify } from "query-string"
import { farasod } from "./api"

const endpoint = "/category"

export const getCategories = async queries => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const addCategory = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const getCategory = async categoryId => {
  const response = await farasod.get(`${endpoint}/${categoryId}`)

  return response.data
}

export const editCategory = async (categoryId, data) => {
  const response = await farasod.patch(`${endpoint}/${categoryId}`, data)

  return response.data
}

export const deleteCategory = async (categoryId) => {
  const response = await farasod.delete(`${endpoint}/${categoryId}`)

  return response.data
}